import type { RouteRecordRaw } from 'vue-router';
import RouteLayout from '../RouteLayout.vue';

export const diaryRoutes: RouteRecordRaw = {
  path: 'diary',
  component: RouteLayout,
  children: [
    {
      path: '',
      name: 'tabs-diary',
      component: () => import('@/views/DiaryRouter.vue'),
    },
    {
      path: 'v1',
      name: 'tabs-diary-v1',
      component: () => import('@/views/DiaryPage.vue'),
    },
    {
      path: 'add-food',
      name: 'tabs-diary-add-food',
      component: () => import('@/views/AddFoodRoutePage.vue'),
    },
  ],
};
